import copy from 'copy-to-clipboard';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import { ClickTracking } from '@/components/ClickTracking';
import { useJoinWithLocale } from '@/hooks';
import { PenPaperIcon, SquareStackIcon } from '@/icons';
import { type ReturnZepIcon } from '@/icons/ZepIcon';
import { type QuizListType } from '@/shared/quizList/QuizListType';
import { alertDialog, Button, type ButtonProps } from '@/ui_v3';
import { cn } from '@/utils';
const ProfileActionButton = (props: Pick<ButtonProps, 'intent' | 'onClick' | 'children' | 'className'> & {
  icon: ReturnZepIcon;
}) => {
  return <Button leftSlot={<props.icon className={'hidden shrink-0 tablet-sm:block'} size={'sm'} />} size={'sm'} intent={props.intent} variant={'outlined'} className={cn('w-full tablet-lg:w-fit', props.className)} onClick={props.onClick} data-sentry-element="Button" data-sentry-component="ProfileActionButton" data-sentry-source-file="ProfileActionButton.tsx">
      {props.children}
    </Button>;
};
export const ProfileEditButton = () => {
  const router = useRouter();
  const {
    t
  } = useTranslation(['common']);
  return <ProfileActionButton icon={PenPaperIcon} intent={'neutral'} onClick={() => {
    void router.push('/profile/edit');
  }} data-sentry-element="ProfileActionButton" data-sentry-component="ProfileEditButton" data-sentry-source-file="ProfileActionButton.tsx">
      {t('profileEdit')}
    </ProfileActionButton>;
};
export const ProfileShareButton = (props: {
  userHashId: string;
  event: {
    location: QuizListType;
    username?: string;
    userEmail?: string;
  };
}) => {
  const {
    event
  } = props;
  const {
    t
  } = useTranslation(['common']);
  const joinWithLocale = useJoinWithLocale();
  return <ClickTracking eventName={'copy_profile_link'} eventProperties={{
    location: event.location,
    username: event.username,
    userEmail: event.userEmail
  }} data-sentry-element="ClickTracking" data-sentry-component="ProfileShareButton" data-sentry-source-file="ProfileActionButton.tsx">
      <ProfileActionButton intent={'alternative'} onClick={async () => {
      copy(`${window.location.origin}${joinWithLocale(`/profile/${props.userHashId}`)}`);
      alertDialog.open({
        header: {
          title: t('common:profile.copyAlert.title')
        },
        body: t('common:profile.copyAlert.description')
      });
    }} icon={SquareStackIcon} data-sentry-element="ProfileActionButton" data-sentry-source-file="ProfileActionButton.tsx">
        {t('common:profile.copy')}
      </ProfileActionButton>
    </ClickTracking>;
};